import {get} from '../utils'
import { getActiveClient, getStoredUser } from "../authentication/utils";

export default host => (id) =>
  get(`${host}/playlists/${id}/downloadLink?client_id=${getActiveClient()}${getStoredUser() ? `&user_id=${getStoredUser().id}` : ''}`)
    .then(response => response.text())